var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1901 11.3224L19.7452 3.64746H18.1915L12.5014 10.3112L7.95443 3.64746H2.71094L9.58574 13.7253L2.71094 21.7731H4.26456L10.2745 14.7352L15.0765 21.7731H20.32L13.1901 11.3224ZM11.063 13.8134L10.3664 12.81L4.82387 4.82563H7.20998L11.6818 11.2693L12.3784 12.2727L18.1928 20.6493H15.8067L11.063 13.8134Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.fc324d0b1d0a6c8b459d13bf49adc201.svg";
export { ForwardRef as ReactComponent };